export const FARM_ADJECTIVES = [
  "Happy",
  "Muddy",
  "Jolly",
  "Rusty",
  "Golden",
  "Green",
  "Sunny",
  "Busy",
  "Sleepy",
  "Loud",
  "Fast",
  "Slow",
  "Old",
  "New",
  "Big",
  "Small",
  "Fancy",
  "Plain",
  "Wild",
  "Tame",
  "Lucky",
  "Brave",
  "Calm",
  "Wise",
  "Silly",
  "Fresh",
  "Dusty",
  "Bright",
  "Cozy",
  "Grand",
];

export const FARM_NOUNS = [
  "Tractor",
  "Barn",
  "Cow",
  "Pig",
  "Chicken",
  "Horse",
  "Sheep",
  "Goat",
  "Duck",
  "Farmer",
  "Field",
  "Crop",
  "Corn",
  "Wheat",
  "Hay",
  "Silo",
  "Fence",
  "Gate",
  "Plow",
  "Truck",
  "Rooster",
  "Cat",
  "Dog",
  "Mouse",
  "Owl",
  "Bee",
  "Garden",
  "Orchard",
  "Meadow",
  "Brook",
];

export function generateFarmName(): string {
  const adj =
    FARM_ADJECTIVES[Math.floor(Math.random() * FARM_ADJECTIVES.length)];
  const noun = FARM_NOUNS[Math.floor(Math.random() * FARM_NOUNS.length)];
  return `${adj} ${noun}`;
}
